module.exports = __webpack_public_path__ + "static/media/Battery Jump Start.de81dfa5.png";